import React, { useState, useEffect, useContext, useRef, useCallback } from 'react'
import { pageLeftVariants, pageRightVariants, reset } from '../../../utils/frame-motion-variants'
import { motion } from 'framer-motion'
import { downloadAllFitnessPackages } from '../../../api/personal-trainer/personal-trainer-api'
import { UserContext } from '../../../context/UserContext';
import { SystemError } from '../../error/SystemError';
import { FaHeart } from 'react-icons/fa'
import { PullToRefresh } from '../../commons/PullToRefresh'
import { InfiniteScroll } from '../../commons/InfiniteScroll'
import { uploadInterest } from '../../../api/listing/listing-api';
import { openModal } from '../../../service/modal-service';
import { PackageView } from '../../service-provider/personal-trainer/PackageView';
import { getLastRouter } from '../../../service/history';
import { PersonalTrainerPackageImages } from '../../service-provider/personal-trainer/PersonalTrainerPackageImages';
import { LoadingCover } from '../../commons/LoadingCover';
import { useRouter } from 'next/router';

export const FitnessDeals = (props) => {
    const requestRoute = props.requestRoute

    const fitnessDeals = props.fitnessDeals

    const countryName = props.countryName
    
    const lastRoute = getLastRouter()

    const router = useRouter()
    
    let variants
    if( lastRoute === "/home/buzz" || lastRoute === "/notification"){
        variants = pageLeftVariants
    } else {
        variants = pageRightVariants
    }

    const [ isFitnessDealsRefresh, setIsFitnessDealsRefresh ] = useState(false);
    const [ fitnessDealsIncrementSize, setFitnessDealsIncrementSize ] = useState(12)
    const [ isShowMoreFitnessDeals, setIsShowMoreFitnessDeals ] = useState(true)
    const [ isLoadingFitnessDeals, setIsLoadingFitnessDeals ] = useState(false)
    const [ isShowTopSection, setIsShowTopSection ] = useState(true)
    const [ isSendingInterest, setIsSendingInterest ] = useState('')
    const [ packageView, setPackageView ] = useState({})
    const [ showPackageView, setShowPackageView ] = useState(false)

    const [ sortBy, setSortBy ] = useState("Recommended")
    const [ typeFilter, setTypeFilter ] = useState('All')
    const [ isFilterChange, setIsFilterChange ] = useState(false)
    const orderBy = useRef("a.recommend_val")
    const orderClause = useRef('DESC')

    const [ isLoading, setIsLoading ] = useState(false)
    const [ isSystemError, setIsSystemError ] = useState(false)
    const [ errorContent, setErrorContent ]  = useState({'header': "", 'body': ""}) 

    const { userId, userCountryName, setUserCountryName, 
        fitnessDealsLowerLimit,
        setFitnessDealsLowerLimit,
        fitnessDealsArray,
        setFitnessDealsArray } = useContext(UserContext)    

    const setParams = useCallback(() => {
        switch (sortBy){
            case "Recommended":
                orderClause.current = "DESC"; 
                orderBy.current = "a.recommend_val";
            break;
            case "Cheapest Package":
                orderClause.current = "ASC"; 
                orderBy.current = "a.cost";
            break;
            case "Latest":
                orderClause.current = "DESC"; 
                orderBy.current = "a.add_timestamp";
            break;
            case "Best Discount":
                orderClause.current = "DESC"; 
                orderBy.current = "(a.original_cost - a.cost) * 100/a.original_cost";
            break;
            case "Cheapest per Session":
                orderClause.current = "ASC"; 
                orderBy.current = "a.cost/(a.unit_quantity *  a.session_count)";
            break;
            default:
                orderClause.current = "DESC"; 
                orderBy.current = "a.recommend_val";
        }
    }, [sortBy, orderBy, orderClause])

    useEffect(() => {
        if(countryName){
            setUserCountryName(countryName)
        }
    },[countryName, setUserCountryName])

    useEffect(() => {
        if(fitnessDeals && fitnessDealsLowerLimit === 0){
            setFitnessDealsArray(fitnessDeals)
            setFitnessDealsLowerLimit(fitnessDealsIncrementSize)
            if (fitnessDeals.length < fitnessDealsIncrementSize) {
                setIsShowMoreFitnessDeals(false);
            }
            setParams()
            setIsLoadingFitnessDeals(false)
        }
    },[fitnessDeals, fitnessDealsIncrementSize, fitnessDealsLowerLimit, setParams, setFitnessDealsArray, setFitnessDealsLowerLimit])

    const handleType = (type) =>{
        if(typeFilter != type){
            setTypeFilter(type)
            setIsFilterChange(true)
        }
    }

    const handleSortByChange = (e) => {
        if(sortBy != e.target.value){
            setSortBy(e.target.value)
            setIsFilterChange(true)
        }
    }  

    const getAllFitnessPackages = useCallback(async() =>{   
        if(!orderClause.current || !orderBy.current)  return
        try {
            let response = await downloadAllFitnessPackages(typeFilter, userCountryName, "N", fitnessDealsIncrementSize, fitnessDealsLowerLimit, orderClause.current, orderBy.current)
            setIsLoadingFitnessDeals(false);
            if (fitnessDealsLowerLimit === 0) {
                if(response.length > 0){
                    setFitnessDealsArray(response);
                    if (response.length < fitnessDealsIncrementSize) {
                        setIsShowMoreFitnessDeals(false);
                    }
                }
            } else {
                let newItemCount = response.length;
                setFitnessDealsArray(fitnessDealsArray => [...fitnessDealsArray, ...response]);
                if (newItemCount < fitnessDealsIncrementSize) {
                    setIsShowMoreFitnessDeals(false);
                }
            }
        } catch (error) {
            console.log(error);
            setErrorContent({ 'header': "Error loading this filter", 'body': "Please try again. If problem persists, contact us at support@stringssg.com" });
            setIsSystemError(true);
            setIsLoadingFitnessDeals(false);
        }
    }, [typeFilter, userCountryName, fitnessDealsIncrementSize, fitnessDealsLowerLimit, setFitnessDealsArray])

    
    const expressInterest = async(listingId, listingOwnerId, title) =>{
        //setIsSendingInterest(listingId)
        try {
            if(!userId){
                await uploadInterest('Fitness Trainer', listingId, listingOwnerId, "anonymous", title)
            } else {
                await uploadInterest('Fitness Trainer', listingId, listingOwnerId, userId, title)
            }   
        } catch (error) {
            console.log(error);
            setErrorContent({ 'header': "Error sending Interest", 'body': "Please try again. If problem persists, contact us at support@stringssg.com" });
            setIsSystemError(true);
            setIsLoading(false)
        }
    }

    const refreshFitnessDeal = useCallback(async() =>{
        return new Promise((resolve, reject) => {
            setIsShowMoreFitnessDeals(true)
            setIsLoadingFitnessDeals(true)
            setIsFitnessDealsRefresh(true)
            setFitnessDealsLowerLimit(0)
            setParams()
            resolve("success");
        })
    }, [ setParams, setFitnessDealsLowerLimit ])

    // for refresh
    useEffect(() => {
        if (!isFitnessDealsRefresh)
            return;
        setIsFitnessDealsRefresh(false);
        getAllFitnessPackages();
    }, [isFitnessDealsRefresh, getAllFitnessPackages]);

    const loadMoreFitnessDeals = async() =>{
        setIsLoadingFitnessDeals(true); 
        return new Promise((resolve, reject) => {     
            if( fitnessDealsArray.length > 0){                
                setFitnessDealsLowerLimit(fitnessDealsLowerLimit + fitnessDealsIncrementSize);
            }              
            resolve("success");
        });
    }

    // for filter change 
    useEffect(() => {
        if(!isFilterChange) return
            refreshFitnessDeal()
            setIsFilterChange(false)
    }, [isFilterChange, refreshFitnessDeal])

    // for infinitescroll
    useEffect(() => {     
        if(fitnessDealsLowerLimit === 0 || isFilterChange) return;
        getAllFitnessPackages();
    }, [fitnessDealsLowerLimit, isFilterChange, getAllFitnessPackages] )    

    
    useEffect(() => {
        if(requestRoute){
            setIsShowTopSection(false)
        }
        if(!userCountryName) return
        
        if(fitnessDealsArray.length > 0 || fitnessDeals) return
        
        setParams()
        setIsLoadingFitnessDeals(true); 

        getAllFitnessPackages()

    }, [userCountryName, getAllFitnessPackages, setParams, requestRoute, fitnessDealsArray, fitnessDeals ])

    const contactListingUser = (listingId, listingOwnerId, title) => {
        setIsLoading(true)                
    }
    
    const viewDescription = (listing) =>{
        expressInterest(listing.listingId, listing.userId, listing.title)
        setPackageView(listing)
        const ele = document.getElementsByClassName("ptr__children")[0];
        if(ele){
            ele.style.transform = null;
        }
        openModal(setShowPackageView)
    }

  return (
    <div>
        <div className='max-w-5xl mx-auto my-5' id="fitness-deals">   
            {isShowTopSection &&
                <div className='space-y-2 px-2'>
                    <div className="overflow-x-auto whitespace-nowrap text-center w-full scrollbar-hide space-x-2 text-sm">
                        <button type="button" className={"px-3 py-1 bg-white text-orange-600 " + (typeFilter == 'All' && 'border-b border-b-amber-500')}  
                            onClick={() => handleType('All')}>All
                        </button>
                        <button type="button" className={"px-3 py-1 bg-white text-orange-600 " + (typeFilter == 'Free Trial' && 'border-b border-b-amber-500')} 
                            onClick={() => handleType('Free Trial')}>Free Trial
                        </button>
                        <button type="button" className={"px-3 py-1 bg-white text-orange-600 " + (typeFilter == 'Standard' && 'border-b border-b-amber-500')} 
                            onClick={() => handleType('Standard')}>Standard
                        </button>
                        <button type="button" className={"px-3 py-1 bg-white text-orange-600 " + (typeFilter == 'Corporate' && 'border-b border-b-amber-500')} 
                            onClick={() => handleType('Corporate')}>Corporate
                        </button>
                        {/* <button type="button" className={"px-3 py-1 bg-white text-orange-600 " + (typeFilter == 'One-time' && 'border-b border-b-amber-500')}  
                            onClick={() => handleType('One-time')}>One-time
                        </button>
                        <button type="button" className={"px-3 py-1 bg-white text-orange-600 " + (typeFilter == 'Hourly' && 'border-b border-b-amber-500')}  
                            onClick={() => handleType('Hourly')}><span></span>Hourly
                        </button>
                        <button type="button" className={"px-3 py-1 bg-white text-orange-600 " + (typeFilter == 'Weekly' && 'border-b border-b-amber-500')}  
                            onClick={() => handleType('Weekly')}>Weekly
                        </button>
                        <button type="button" className={"px-3 py-1 bg-white text-orange-600 " + (typeFilter == 'Monthly' && 'border-b border-b-amber-500')} 
                            onClick={() => handleType('Monthly')}>Monthly
                        </button> */}
                    </div>
                    <div >			 
                        <select className="indent-2 h-11 text-sm text-orange-600 border shadow-sm bg-white rounded-xl focus:shadow-sm focus:shadow-amber-200 focus:outline-none focus:ring-1 ring-amber-200" 
                            type="text" name="sortBy" value={sortBy} onChange={(e) => handleSortByChange(e)} style={{ transition: "all .15s ease" }}>
                                <option>Recommended</option>
                                <option>Cheapest Package</option>
                                <option>Cheapest per Session</option>
                                <option>Best Discount</option>
                                <option>Latest</option>
                        </select>
                    </div>
                </div>
            }
            <PullToRefresh
                onRefresh={refreshFitnessDeal}
                isPullable={isShowTopSection}
                pullingContent={<div className='text-sm text-gray-500 text-center'>&#8595; pull to refresh</div>}
                pullDownThreshold={90}
                maxPullDownDistance={200}
            >
                <InfiniteScroll
                    loadMore={loadMoreFitnessDeals}
                    hasMore={isShowMoreFitnessDeals && !isLoadingFitnessDeals && isShowTopSection}
                    loader={
                        <div className='flex justify-center p-5'>
                            <span className="loader">Loading more...</span>
                        </div>
                    }
                >
            {isLoadingFitnessDeals &&
                <div className='flex justify-center p-5'>
                    <span className="loader">Loading...</span>
                </div>
            }
            {fitnessDealsArray.length === 0 &&
                <div className='flex justify-center my-5'>
                    <span className='text-gray-500 text-sm'>No deals available for this selection</span>
                </div>
            }
            <div className={(isShowTopSection ? " grid grid-cols-2 md:grid-cols-3 p-2 " : "overflow-auto scrollbar-hide sm:grid sm:grid-cols-2 whitespace-nowrap w-full gap-5 space-x-2 sm:space-x-0 ") + (' ')}>
                {[...fitnessDealsArray].map((listing, i)=>
                    <div key={i} className={(isShowTopSection ? " " : "  w-3/5 sm:w-full inline-block h-full relative") + (' bg-linear-to-bl from-gray-200 to-white shadow mb-2 pb-4 cursor-pointer rounded-2xl overflow-hidden')} onClick={() => viewDescription(listing)}>
                        <PersonalTrainerPackageImages listing={listing}/>
                        <div className='relative h-44'>
                            <h3 className='text-orange-600 p-2 text-sm'>{listing.title}</h3>
                            {(listing.corporateInd === "Y" || listing.type === "Corporate") &&
                                <div className='text-xs text-white px-2 pb-2'>
                                    <span className='px-2 py-1 bg-blue-600  rounded-full'>
                                        corporate
                                    </span>
                                </div>
                            }
                            <div className='text-sm px-2 space-y-1'>
                                <div className='flex items-center'>
                                    {(listing.type == 'Free Trial' || listing.type == 'One-time') ?
                                    (
                                        <div className=''>
                                            {listing.type}
                                        </div>
                                    )    
                                        :
                                    (
                                        <div className=''>
                                            <span>{listing.unitQuantity}&nbsp;
                                                {(listing.type == 'Standard' || listing.type == 'Corporate')  &&
                                                    <span>Session/s</span>
                                                }
                                                {listing.type == 'Hourly' &&
                                                    <span>Hour/s</span>
                                                }
                                                {listing.type == 'Weekly' &&
                                                    <span>Week/s</span>
                                                }
                                                {listing.type == 'Monthly' &&
                                                    <span>Month/s</span>
                                                }
                                            </span>
                                        </div>
                                    )
                                    }  
                                </div>
                                <div className=''>
                                    {listing.type == 'Weekly' &&
                                        <div>
                                            <span className='text-gray-500 font-bold'>Session/week:&nbsp;</span><span className='text-orange-600'>{listing.sessionCount}</span>
                                        </div>
                                        
                                    }
                                    {listing.type == 'Monthly' &&
                                        <div>
                                            <span className='text-gray-500 font-bold'>Session/month:&nbsp;</span><span className='text-orange-600'>{listing.sessionCount}</span>
                                        </div>
                                    }
                                </div>
                                <div className=''>
                                    <span className=''>{listing.currencyCd} {listing.cost}</span>
                                    {listing.originalCost > 0 &&
                                        <span className='text-gray-500'>/<del>{listing.currencyCd} {listing.originalCost}</del></span>
                                    }
                                    <br/><span className='text-xs'>({listing.currencyCd} {listing.perSession} per session)</span>                                                                
                                </div>
                            </div>
                            <div className="text-xs absolute bottom-0 w-full p-2 space-y-2">												
                                <div className='flex justify-center items-center'>
                                    {/* <button type="button" className="px-2 py-2 text-orange-600 shadow-sm rounded-full">Details</button>	 */}
                                    
                                    <div className="flex justify-end items-center text-sm"><span className='text-orange-600'>{listing.interestCount}&nbsp;</span> 
                                    <FaHeart className='text-base text-red-500'/></div>
                                </div>
                                {/* <div className='flex justify-center'>
                                    {(listing.corporateInd === 'N' && listing.type != "Corporate")?
                                        <button type="button" className="px-3 py-2 shadow text-orange-600 rounded-lg text-xs" 
                                            onClick={() => contactListingUser(listing.listingId, listing.userId, listing.title)}>Contact
                                        </button>
                                    :
                                        <span className="text-orange-600">Email us at <strong><a href="mailto: support@stringssg.com">support@stringssg.com</a></strong></span>                               
                                    }
                                </div>                                     */}
                            </div>
                        </div>
                    </div>
                )}
            </div>
                </InfiniteScroll>
            </PullToRefresh>
        </div>
        {showPackageView && 
            <PackageView packageView={packageView}/>
        }
        {isLoading &&
            <LoadingCover/>
        }
        {isSystemError && <SystemError errorContent={errorContent} setIsSystemError={setIsSystemError}/>}
    </div>
  )
}
